import { Flex, theme, Typography } from 'antd';
import { EXTERNAL_FORM_DEFAULTS } from '@/features/externalForm/constants';

const { Title, Text } = Typography;

export const CreateQuotationHeader = ({ isExternal, title, subtitle, logo }) => {
  const { token: themeToken } = theme.useToken();

  const resolvedTitle = isExternal
    ? (title || EXTERNAL_FORM_DEFAULTS.title)
    : '¡A un paso más cerca de tu cliente!';

  const resolvedSubtitle = isExternal
    ? (subtitle || EXTERNAL_FORM_DEFAULTS.subtitle)
    : 'Obtén cotizaciones en segundos';

  const titleNode = isExternal ? (
    <Title level={3} style={{ color: themeToken.colorPrimary, margin: 0 }}>{resolvedTitle}</Title>
  ) : (
    <Title style={{ color: themeToken.colorPrimary, margin: 0 }}>{resolvedTitle}</Title>
  );
  const subtitleNode = (
    <Text style={{ color: themeToken.colorPrimary }}>{resolvedSubtitle}</Text>
  );

  if (isExternal && logo) {
    return (
      <Flex align='center' gap={16} wrap='wrap'>
        <img
          src={logo}
          alt='Logo de la agencia'
          style={{ maxHeight: 48, maxWidth: 180, objectFit: 'contain' }}
        />
        <Flex vertical gap={4} style={{ flex: '1 1 200px', minWidth: 0 }}>
          {titleNode}
          {subtitleNode}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex vertical align='center' gap={8} style={{ textAlign: 'center' }}>
      {titleNode}
      {subtitleNode}
    </Flex>
  );
};
